import {EntityViewModel} from "../../../../infrastructure/models/entity/entity.view-model";
import {DescriptionHeaderViewModel} from "./description-header.view-model";
import {COLORS} from "../../../app/consts/colors";

export class DescriptionHeaderStaticViewModel extends DescriptionHeaderViewModel {
  get id(): Number {
    return null
  }

  get color(): String {
    return COLORS.blackPrimary
  }

  get textureId(): Number {
    return null
  }

  get objectType(): EntityViewModel {
    return null;
  }

  get popularityRank(): String {
    return null;
  }

  get shouldRenderPopularityRank(): Boolean {
    return false
  }
}